// ============================================================
// 彩蛋：Konami 指令 + Logo 连点 + 键盘暗号 jkl + PANZER 坦克 + 光标光晕
// ============================================================

import { showToast, glitchScreen, tankScreen } from "./ui";

const KONAMI = [
  "ArrowUp",
  "ArrowUp",
  "ArrowDown",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight",
  "ArrowLeft",
  "ArrowRight",
  "b",
  "a",
];

export default function initEasterEggs(matrixApi) {
  // ---------- 光标光晕（仅精确指针设备） ----------
  if (window.matchMedia("(pointer: fine)").matches) {
    const glow = document.createElement("div");
    glow.className = "cursor-glow";
    document.body.appendChild(glow);

    let tx = -100;
    let ty = -100;
    let x = -100;
    let y = -100;
    let raf = 0;

    document.addEventListener("mousemove", (e) => {
      tx = e.clientX;
      ty = e.clientY;
      if (!raf) raf = requestAnimationFrame(move);
    });

    const move = () => {
      raf = 0;
      x += (tx - x) * 0.16;
      y += (ty - y) * 0.16;
      glow.style.transform = `translate(${x - 110}px, ${y - 110}px)`;
      if (Math.abs(tx - x) > 0.5 || Math.abs(ty - y) > 0.5) {
        raf = requestAnimationFrame(move);
      }
    };
  }

  // ---------- Konami ----------
  let seq = [];
  document.addEventListener("keydown", (e) => {
    // 终端输入框内不触发键盘彩蛋
    const tag = document.activeElement?.tagName;
    if (tag === "INPUT" || tag === "TEXTAREA") return;

    const key = e.key.length === 1 ? e.key.toLowerCase() : e.key;
    seq.push(key);
    if (seq.length > KONAMI.length) seq.shift();

    const hit = seq.length === KONAMI.length && seq.every((k, i) => k === KONAMI[i]);
    if (hit) {
      seq = [];
      matrixApi?.setMode("overdrive");
      glitchScreen(1500);
      showToast("🕹 KONAMI ✓ 已解锁：矩阵超频模式（8 秒）", 3600);
    }
  });

  // ---------- 键盘暗号：jkl ----------
  let buffer = "";
  document.addEventListener("keydown", (e) => {
    const tag = document.activeElement?.tagName;
    if (tag === "INPUT" || tag === "TEXTAREA") return;
    if (!/^[a-z]$/i.test(e.key)) {
      buffer = "";
      return;
    }
    buffer = (buffer + e.key.toLowerCase()).slice(-3);
    if (buffer === "jkl") {
      buffer = "";
      matrixApi?.setMode("overdrive");
      showToast("🕶 暗号 JKDY 已识别 —— 导演一直在线", 3400);
    }
  });

  // ---------- PANZER：GTA 罪恶都市坦克秘籍 ----------
  // 键盘连续输入 p-a-n-z-e-r（大小写均可）触发坦克彩蛋
  const PANZER = ["p", "a", "n", "z", "e", "r"];
  let panzerSeq = [];
  document.addEventListener("keydown", (e) => {
    const tag = document.activeElement?.tagName;
    if (tag === "INPUT" || tag === "TEXTAREA") return;

    // 仅接受字母按键，非字母（方向键等）重置序列
    const key = e.key.length === 1 ? e.key.toLowerCase() : "";
    if (!key) {
      panzerSeq = [];
      return;
    }

    panzerSeq.push(key);
    if (panzerSeq.length > PANZER.length) panzerSeq.shift();

    // 完整匹配 panzer 序列后触发
    if (panzerSeq.length === PANZER.length && panzerSeq.every((k, i) => k === PANZER[i])) {
      panzerSeq = [];
      tankScreen();
      showToast("🪖 PANZER ✓ 坦克已部署 —— RHINO 已就位", 3400);
    }
  });

  // ---------- Logo 连点 ----------
  const logo = document.getElementById("nav-logo");
  if (logo) {
    let clicks = 0;
    let resetTimer = null;
    logo.addEventListener("click", () => {
      clicks += 1;
      clearTimeout(resetTimer);
      resetTimer = setTimeout(() => (clicks = 0), 2000);
      if (clicks >= 5) {
        clicks = 0;
        glitchScreen(1200);
        showToast("导演在吗？—— 在的，一直在。系统从未下线。", 3600);
      }
    });
  }
}
